module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Model-Q-1164.7c70f58c.jpg";